export default {
      id: "i-checked2-usage",
      viewBox: "0 0 12 10",
      url: __webpack_public_path__ + "img/sprite.svg#i-checked2",
      toString: function () {
        return this.url;
      }
    }